<template>
  <div id="new-cast" class="cast col offset-lg-1 col-lg-10">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
            <img class="cast-svg" svg-inline src="../assets/document.svg">
            <p class="instructions-header">Take your original media file</p>
        </div>
        <div class="col-lg-6">
          <div class="vert-mid instructions-short">
            1. Calculate a sha256 hash<br>
            2. Add a description<br>
            3. Publish on the blockchain<br>
          </div>
        </div>
      </div>
      <div class="row blockseparator">
        <div class="col-lg-4"></div>
        <div class="col-lg-4">
          <div class="separator">
                <img class="sep-img" svg-inline src="../assets/separator.svg">
          </div>
        </div>
        <div class="col-lg-4"></div>
      </div>
    </div>

    <router-view></router-view>
  </div>

</template>

<script>
  import Vue               from 'vue'
  import { mapActions
         , mapGetters
         , mapState      } from 'vuex'

  export default {
    name: 'CastNew'
  , components: {}
  , data () {
      return {
      }
    }
  , computed: {
    }
  , methods: {
    }
  , mounted() {
      this.$store.dispatch('init')
    }
  }
</script>

<style scoped>
  .new-cast {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .cast-svg {
    position: relative;
    max-height: 20em;
  }
</style>



// WEBPACK FOOTER //
// src/components/CastNew.vue